/* eslint-disable no-tabs */
/**
 * Gamma Correction Shader
 * http://en.wikipedia.org/wiki/gamma_correction
 */

const GammaCorrectionShader = {

  name: 'GammaCorrectionShader',

  uniforms: {

    tDiffuse: { value: null },

  },

  vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

  fragmentShader: /* glsl */`

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

        vec4 sRGBTransferOETF1( in vec4 value ) {
             return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.03 - vec3( 0.03 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
        }
		void main() {

			vec4 tex = texture2D( tDiffuse, vUv );

			gl_FragColor = sRGBTransferOETF1( tex );

		}`,

}

export default GammaCorrectionShader
